$(document).ready(function(){
	if(!document.getElementById('stepSelectSwapPlan')) return false;

	// select esp and check esp product
	if(!document.querySelector('.check-esp')) return false;
	var step = {
		el: document.getElementById('stepSelectSwapPlan'), // form
		selectForm: document.getElementById('stepSelectProduct'),
		forms: document.querySelectorAll('.js-step-form'), // all of step forms
		init: function() {
			$(step.selectForm).data('ajaxurl', step.selectForm.getAttribute('data-authorized-check'));
			step.addEvent();
		},
		activationSteps: function(isESP){
			var _forms = step.forms,
				_target = isESP ? '.esp' : '.none-esp';
			for (var i = 0; i < _forms.length; i++) {
				var _form = _forms[i],
					_activateTarget = _form.querySelector(_target);
				$(_activateTarget).show().removeAttr('disabled')
					.siblings('fieldset').hide().attr('disabled', 'disabled');
			};

			$('.request-swap').length && $('#step_select_product .field-btn-area button[form="stepSelectProduct"]').attr('aria-describedby', (isESP ? 'espStep3HeadTitle' : 'step3HeadTitle') ); // LGEUS-816 20200818 add

			var _steps = document.querySelectorAll('.step-cluster');

			if(isESP) {
				step.selectForm.setAttribute('data-authorized-check', $(step.selectForm).data('ajaxurl'));
				$(_steps).removeAttr('style').removeClass('disabled');
				for (var i = 0; i < _steps.length; i++) {
					var _curStep = _steps[i];
					$(_curStep.querySelector('span.num')).text(Number(_curStep.getAttribute('data-idx'))+1);
				}
			}else {
				step.selectForm.removeAttribute('data-authorized-check');
				$('#step_your_service_type').addClass('disabled').next().show();
				var idx = $(_steps).filter('#step_your_service_type').index();
				for (var i = idx; i < _steps.length; i++) {
					var _curStep = _steps[i];
					$(_curStep.querySelector('span.num')).text(Number(_curStep.getAttribute('data-idx')));
				}
			}
			// $(s.querySelector(_target)).show().siblings().hide();
			$(_forms).closest('.step-cluster').find(_target).show().siblings(':not(".image")').hide();
			$(step.el).trigger('submit:confirmed');
		},
		beforeSubmit: function(e){
			e.preventDefault();
			// ajax validation
			if($(step.el).checkValidation()) {
				var value = $(step.el).find('input[name="ESP"]:checked').val();
				step.activationSteps(value === 'yes');
			}
		},
		addEvent: function(){
			$(step.el).on({
				submit: step.beforeSubmit
			});
		}
	};
	step.init();
});